module.exports = __webpack_public_path__ + "img/profit.b7558189.png";